/* eslint-disable */
import NumberInput from './NumberInput';

export default NumberInput;
